'use client';

// Third Party Plugins
import React from 'react';
import { faSearch, faTh, faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Types
import { SearchFormProps } from './types';

// Styles
import {
  LayoutButtonsContainer,
  SearchButtonsContainer,
  StyledForm,
  StyledButton,
  StyledSearchIcon,
} from './styles';
import { StyledInput } from '@/components/forms/FormInput/styles';

// Custom Components
import Button from '@/components/buttons/BaseButton';

const SearchForm: React.FC<SearchFormProps> = ({
  searchTerm,
  setSearchTerm,
  searchMode = 'title',
  setSearchMode,
  isGrid,
  setIsGrid,
}) => {
  // stop form from submitting and scrolling to top of page
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
  };

  return (
    <>
      <SearchButtonsContainer>
        {/* Buttons to switch between search modes */}
        <Button actionType="button" action={() => setSearchMode('title')}>
          Search by Title
        </Button>

        <Button actionType="button" action={() => setSearchMode('subject')}>
          Search by Subject
        </Button>

        <Button actionType="button" action={() => setSearchMode('author')}>
          Search by Author
        </Button>
      </SearchButtonsContainer>

      <StyledForm role="search" onSubmit={handleSubmit}>
        <StyledInput
          id="searchInput"
          style={{ background: `var(--c-white)` }}
          placeholder={`Search by ${searchMode.charAt(0).toUpperCase() + searchMode.slice(1)}`}
          type="search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          aria-label={`Search By ${searchMode.charAt(0).toUpperCase() + searchMode.slice(1)}`}
        />

        <StyledSearchIcon icon={faSearch} />

        <LayoutButtonsContainer>
          <StyledButton onClick={() => setIsGrid(true)} $active={isGrid}>
            <FontAwesomeIcon icon={faTh} />
            Grid
          </StyledButton>

          <StyledButton onClick={() => setIsGrid(false)} $active={!isGrid}>
            <FontAwesomeIcon icon={faList} />
            List
          </StyledButton>
        </LayoutButtonsContainer>
      </StyledForm>
    </>
  );
};

export default SearchForm;
